import { render, staticRenderFns } from "./ChildOrgSearch.vue?vue&type=template&id=16bf7084"
import script from "./ChildOrgSearch.vue?vue&type=script&lang=js"
export * from "./ChildOrgSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports